var map = {
  "./da.json": [
    "98202",
    [
      43207
    ]
  ],
  "./fi.json": [
    "31960",
    [
      9601
    ]
  ],
  "./sv.json": [
    "61756",
    [
      67565
    ]
  ],
  "./ja.json": [
    "82220",
    [
      82397
    ]
  ],
  "./lt.json": [
    "49321",
    [
      17682
    ]
  ],
  "./sl.json": [
    "35382",
    [
      74011
    ]
  ],
  "./fr.json": [
    "40237",
    [
      83614
    ]
  ],
  "./es.json": [
    "92357",
    [
      50758
    ]
  ],
  "./no.json": [
    "69694",
    [
      39475
    ]
  ],
  "./cs.json": [
    "9747",
    [
      18032
    ]
  ],
  "./en.json": [
    "68846",
    [
      52483
    ]
  ],
  "./description/en.json": [
    "35957",
    [
      87670
    ]
  ],
  "./pl.json": [
    "59317",
    [
      5174
    ]
  ],
  "./hu.json": [
    "7482",
    [
      53767
    ]
  ],
  "./nl.json": [
    "56511",
    [
      80052
    ]
  ],
  "./de.json": [
    "72694",
    [
      30715
    ]
  ],
  "./pt.json": [
    "62733",
    [
      19166
    ]
  ],
  "./it.json": [
    "34968",
    [
      41473
    ]
  ],
  "./et.json": [
    "83748",
    [
      11493
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 51492;
module.exports = __rspack_async_context;
